module.exports = __webpack_public_path__ + "fonts/template-update-notice.png!static";